import { TooltipArrow } from '@melements/front-components/dist/components/tooltip/Tooltip.styles';
import styled from 'styled-components';

export const CompanyDataRow = styled.div`
  display: flex;
  position: relative;
  max-width: 90vw;

  img {
    margin: 1rem 0 0 0.75rem;
  }

  div[class*='infoPopup'] {
    transform: translate3d(0.625rem, -5.8125rem, 0) !important;
    top: unset !important;
    bottom: 0;
    right: 0;
    left: unset !important;

    ${TooltipArrow} {
      left: unset !important;
      right: 0.625rem;
    }
  }
`;
export const AccountFormTooltip = styled.div`
  max-width: 15rem;
  line-height: 1.3;
`;
